<template>
    <div class="p-relative">

        <Toolbar :is-list="true" v-on:toolbar-button-click="onToolbarClick">
            <SearchPanel v-model="search" :has-filter="false" />
        </Toolbar>

        <v-data-table
            :loading="loading"
            :headers="headers"
            :items="entities"
            :search="search"
            :options="options"
            :footer-props="{ itemsPerPageOptions: [5, 10, 20] }"
            :page.sync="options.page"
            @page-count="paginationPageCount = $event"
            @dblclick:row="(event, data) => onRowDblClick(data.item)"
            class="elevation-1 customization-list-table pagination-list-table sticky-table"
        >

            <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate />

            <template v-slot:[`item.Value`]="{ item }">
                <div class="elipsis-text-wrap">
                    <div class="etw-text-container">
                        <div class="etw-text" v-tooltip.top-center="item.Value">
                            {{ item.Value }}
                        </div>
                    </div>
                </div>
            </template>

            <template v-slot:[`footer.prepend`]>
                <v-pagination
                    v-model="options.page"
                    :length="paginationPageCount"
                    :total-visible="$listPaginationTotal"
                    color="teal"
                ></v-pagination>
            </template>

        </v-data-table>

        <CreateRequisitesGroupDlg ref="CreateRequisitesGroupDlgRef" />

    </div>
</template>

<script>
import _ from "lodash";
import { mapActions } from 'vuex';
import { httpAPI } from "@/api/httpAPI";

import Toolbar from '@/components/documents/Toolbar.vue';
import SearchPanel from '@/components/documents/SearchPanel.vue';
import CreateRequisitesGroupDlg from '@/views/global/configuration/dialogs/CreateRequisitesGroupDlg.vue';

export default {
    columnIndex:  {
        'document_type': 1,
        'template_name': 2
    },
    name: 'RequisitesGroups',
    components: {
        Toolbar,
        SearchPanel,
        CreateRequisitesGroupDlg
    },
    computed: {
        collection() {
            return 'RequisitesGroups';
        },
        headers() {
            return [
                { text: this.$t("Наименование"), value: 'Value' }
            ];
        },
        search: {
            get: function() {
                let op = this.$store.getters['global/configuration/requisitesGroups/getSearch'];
                return op;
            },
            set: _.debounce(function(v) {
                this.resetPage();
                this.$store.commit('global/configuration/requisitesGroups/SET_SEARCH', v);
            }, 500)
        },
        options: {
            get: function() {
                let op = this.$store.getters['global/configuration/requisitesGroups/getTableOptions'];
                return op;
            },
            set: function(newValue) {
                this.$store.commit('global/configuration/requisitesGroups/SET_TABLE_OPTION', newValue);
            }
        },
        filter () {
            return {
                ...this.options,
                SearchStr: this.search
            }
        }
    },
    data: () => ({
        loading: true,
        total: 0,
        entities: [],
        paginationPageCount: 0
    }),
    methods: {
        ...mapActions(['setOverlayVisible']),
        resetPage() {
            this.$store.commit('global/configuration/requisitesGroups/SET_TABLE_OPTION_PAGE', 1);
        },
        async onToolbarClick(event, button) {
            if (!button.Action)
                return;

            let action = this[button.Action];

            if (action)
                action(button);
        },
        async Refresh() {
            await this.getData();
        },
        async getData() {
            this.total = 0;
            this.entities = [];
            this.loading = true;

            let response = await httpAPI({
                url: `api/document-templates/list?collection=${this.collection}&filter=null`,
                method: 'GET',
                headers: { "isCommon": true }
            });

            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;
            this.loading = false;
        },
        async onRowDblClick(group) {
            await this.$refs.CreateRequisitesGroupDlgRef.open({ requisiteGroup: JSON.parse(JSON.stringify(group)), allowEdit: false });
        }
    },
    created() {
        let fakeMenu =
        [
            { Action: "Refresh", Icon: "refresh", Items: null, Text: this.$t("Обновить"), ToolTip: this.$t("Обновить_форму"), Type: null }
        ];

        this.$store.commit('documents/toolbar/SET_MENU', { menu: fakeMenu });
        this.getData();
    }
}
</script>